import React, { useState } from 'react';
import styled from 'styled-components';

import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import { SingleSelect } from '~/components';

import Connections from './Connections';
import History from './History';
import Integrations from './Integrations';

const listType = {
  HISTORY: 'history',
  INTEGRATIONS: 'integrations',
  CONNECTIONS: 'connections',
};

const Filters = styled.div`
  width: 25%;
  margin-bottom: 1.5rem;
`;

function XeroList({ list }) {
  switch (list) {
    case listType.HISTORY:
      return <History />;
    case listType.INTEGRATIONS:
      return <Integrations />;
    case listType.CONNECTIONS:
      return <Connections />;
    default:
      return null;
  }
}

export default function Xero() {
  useDocumentTitle('Xero - Admin');

  const [list, setList] = useState(listType.HISTORY);

  return (
    <Page>
      <Header />
      <Filters>
        <SingleSelect placeholder="View" value={list} onChange={(event) => setList(event.target.value)}>
          <option value={listType.HISTORY}>Xero History</option>
          <option value={listType.INTEGRATIONS}>Ruddr Integrations</option>
          <option value={listType.CONNECTIONS}>Xero Connections</option>
        </SingleSelect>
      </Filters>
      <XeroList list={list} />
    </Page>
  );
}
